(function ($) {
    "use strict";

    $('body').on('click', '[data-toggle="delete"]', function (event) {
        event.preventDefault();
        var $this = $(this);
        if ($this.hasClass('disabled') || $this.prop('disabled')) {
            return false;
        }
        var frm = $(this).data('target');
        var msg = $(this).data('message');

        Swal.fire({
            title: 'Confirm',
            text: msg ? msg : 'Are you sure you want to delete this item?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            // The global submit guard in scripts.js marks the form as submitting
            // and blocks repeats; marking it here first would make that guard
            // cancel this very submission.
            if (result.isConfirmed) {
                $(frm).submit();
            }
        });
    });
})($);
